function renderCrossSelling() {
    let crossSellingTrigger;
    let crossSellingOverlay = document.querySelector('.dtc-cross-selling__overlay');
    let crossSellingContainer = document.querySelector('.dtc-cross-selling__container');
    let crossSellingClose = document.querySelector('.dtc-cross-selling__close');
    let crossSellingCartCount = document.querySelector('.dtc-cross-selling__cartCount');
    let ctaButton = [...document.querySelectorAll('.dtc-cross-selling-item__cta')];
    let multiVariantButton = [...document.querySelectorAll('.dtc-cross-selling-item__button.multi-variant')];
    let crossSellingSliders = [...document.querySelectorAll('.dtc-cross-selling-item__slider')];
    let quickAddElement = [...document.querySelectorAll('.dtc-cross-selling-item__quickAdd')];
    let multiVariantSelect = [...document.querySelectorAll('.dtc-cross-selling-item__select')];
    let singleVariantButton = [...document.querySelectorAll('.dtc-cross-selling-item__button.single-variant')];
    let productVariants;
    let stickyForm = document.querySelector('#dtc-form');
    let variantInputs;
    let fakeAddToCart;
    let totalQuantity = 1;
    let discount = 0;
    let minItems = 0;
    if(crossSellingCartCount){
        discount = parseInt(crossSellingCartCount.dataset.discount, 10);
        minItems = parseInt(crossSellingCartCount.dataset.minItems, 10);
    }
    crossSellingTrigger = document.querySelector('.dtc-cross-selling__trigger');
    variantInputs = [...document.querySelectorAll('.variant-wrapper .variant-input-wrap .variant-input')];
    productVariants = JSON.parse(document.querySelector('.product-variants-json').innerHTML);
    fakeAddToCart = document.querySelector('.fake-add-to-cart-button');
    new window.theme.CartDrawer()
    document.addEventListener('click', (e) => {
        if (e.target === crossSellingTrigger){
            openCrossSelling();
            // let options = [...document.querySelectorAll('.variant-wrapper .variant-input-wrap .variant-input')];
            // if (options.length > 0){
            //     let checkedOption = options.find( opt => opt.querySelector('input:checked'));
            //     let selectedVariant = productVariants.find( variant => variant.title === checkedOption.dataset.value);
            //     singleVariantATC(selectedVariant.id, crossSellingTrigger)
            //     .then( () => {
            //         openCrossSelling();
            //     })
            //     .catch( error => {
            //         console.error('ERROR:', error);
            //     });
            // } else {
            //     let singleOption = document.querySelector('.product-single__variants option');
            //     let selectedVariant = singleOption.value;
            //     singleVariantATC(selectedVariant, crossSellingTrigger)
            //     .then( () => {
            //         openCrossSelling();
            //     })
            //     .catch( error => {
            //         console.error('ERROR:', error);
            //     });
            // }
            gtag('event', 'PDP_Bundle_Trigger', {
                'button_text': 'Bundle & Save',
                'button_type': 'bundle',
                'value' : 1,
                'page_path': window.location.pathname
            });
        }
        if(crossSellingContainer && crossSellingContainer.classList.contains('open')){
            if (e.target === crossSellingClose || crossSellingClose.contains(e.target) || e.target === crossSellingOverlay) {
                closeCrossSelling();
            }
        }
        if(e.target === fakeAddToCart || fakeAddToCart.contains(e.target)){
            stickyForm.classList.add('show-btn');
        }
        if(e.target === document.querySelector('.close-variant-sticky-form') || document.querySelector('.close-variant-sticky-form').contains(e.target)){
            stickyForm.classList.remove('show-btn');
        }
        variantInputs.forEach( variant => {
            let btnText = 'Build Family Bundle'
            if(crossSellingTrigger){
                btnText = crossSellingTrigger.dataset.btntext
            }
            variant.addEventListener('click', (e) => {
                if(crossSellingTrigger){
                  if (e.target.classList.contains('disabled')){
                      crossSellingTrigger.disabled = true;
                      crossSellingTrigger.innerText = 'Sold out';
                      crossSellingTrigger.style.display = 'none'
                  } else {
                      crossSellingTrigger.disabled = false;
                      crossSellingTrigger.style.display = ''
                      if(!isNaN(discount) && discount > 0){
                        crossSellingTrigger.innerText = `${btnText} - ${discount}% Off`;
                      }else{
                        crossSellingTrigger.innerText = btnText;
                      }
                      
                  }
                }
            });
        });
    });
    
    $('.dtc-cross-selling__products').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        mobileFirst: true,
        infinite: false,
        centerMode: true,
        appendDots: $('.dtc-cross-selling-slider__dots'),
        prevArrow: $('.dtc-cross-selling-slider__leftArrow'),
        nextArrow: $('.dtc-cross-selling-slider__rightArrow'),
        responsive: [
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 2,
                }
            },
            {   
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: "unslick"
            }
        ]
    });

    $('.dtc-cross-selling-item__slider').slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        centerMode: false,
    });

    /*
    * ACCESSIBILITY FIXES START
    */

    // Get a reference to the div
    var elements = document.getElementsByClassName('dtc-cross-selling-item__slider');

    // Loop through the elements
    for (var i = 0; i < elements.length; i++) {
        var div = elements[i];
    
        
        // Set tabindex to -1 for the div and all its focusable descendants
        var focusableElements = div.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
        focusableElements.forEach(function(element) {
            element.setAttribute('tabindex', '-1');
        });
    }

    var okeStars = document.getElementsByClassName('oke-is-clickable');

    for (var i = 0; i < okeStars.length; i++) {
        okeStars[i].setAttribute('tabindex', '-1');
    }

    let itemSlides = document.getElementsByClassName('dtc-cross-selling-item__card');

     // Loop through the elements
     for (var i = 0; i < itemSlides.length; i++) {
        itemSlides[i].removeAttribute('role');
    }

    let silderDots = document.getElementsByClassName('slick-dots');

    //set a timeout to remove the role attribute from the dots
    setTimeout(() => {
        for (var i = 0; i < silderDots.length; i++) {
            silderDots[i].removeAttribute('role');
            let li = silderDots[i].getElementsByTagName('li');
            for (var j = 0; j < li.length; j++) {
                li[j].removeAttribute('aria-controls');
                li[j].removeAttribute('role');
                li[j].removeAttribute('aria-selected');
            }
        }
    }, 1000);

    var childDiv = document.querySelector('.dtc-cross-selling__products .slick-track');
    if(childDiv){
        childDiv.setAttribute('aria-label', 'Cross selling products');
        childDiv.removeAttribute('role');
    }
    /*
    * ACCESSIBILITY FIXES end
    */

    if ($('.dtc-cross-selling-item__slider').hasClass('slick-initialized')){
        $('.dtc-cross-selling-item__slider').each(function(){
            let $slider = $(this);
            $slider.mousedown(function(e){
                e.stopPropagation();
            });
            $slider.on('touchstart', function(e){
                e.stopPropagation();
            });
        });
    }
    
    multiVariantButton.forEach( btn => {
        btn.addEventListener('click', (e) => {
            btn.nextElementSibling.style.display = 'block';
            btn.style.display = 'none';
        })
    });

    multiVariantSelect.forEach( select => {
        select.addEventListener('change', (e) => {
            if (e.target.value != 'Size') {
                select.parentElement.style.display = 'none';
                select.parentElement.previousElementSibling.style.display = 'block';
                singleVariantATC(select.options[select.selectedIndex].dataset.variant, select.parentElement.previousElementSibling)
                .then(() => {
                    totalQuantity++;
                    updateCartItemsCount();
                    select.value = 'Size';
                    setTimeout(() => {
                        select.parentElement.style.removeProperty('display');
                        select.parentElement.previousElementSibling.style.removeProperty('display');
                    }, 2000);
                })
                .catch( error => {
                    console.error('ERROR:', error);
                });
            }
        });
    });
                    
    singleVariantButton.forEach( button => {
        button.addEventListener('click', (e) => {
            singleVariantATC(e.target.dataset.variant, button)
            .then(() => {
                totalQuantity++;
                updateCartItemsCount();    
            })
            .catch( error => {
                console.error('ERROR:', error);
            });
        });
    });

    function openCrossSelling(){
        totalQuantity = 0;
        updateCartItemsCount(); 
        crossSellingContainer.classList.add('open');
        crossSellingOverlay.classList.add('show');
        document.querySelector('html').classList.add('stop-scrolling');
        // checkIfUserInteracts();
    };

    function closeCrossSelling(){
        crossSellingContainer.classList.remove('open');
        crossSellingOverlay.classList.remove('show');
        window.scrollTo(0, 0);
        document.querySelector('html').classList.remove('stop-scrolling');
        closeVariantWindowWithButton();
        document.querySelector(".add-to-cart").style.display = ''
        stickyForm.classList.remove('show-btn');
        if(totalQuantity > 0){
            const $drawer = new window.theme.Drawers('CartDrawer', 'cart');
            $drawer.open();
            const $cartDrawer = new window.theme.CartDrawer(); 
        }
    };

    function formatMessage(template, replacements) {
        let msg = template;
        Object.keys(replacements).forEach(key => {
            const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
            msg = msg.replace(regex, replacements[key]);
        });
        return msg;
    }

    function updateCartItemsCount(){   
        if(minItems > 0 && discount > 0){
            if ((totalQuantity + theme.settings.printcount) >= minItems) {
                // threshold reached
                crossSellingCartCount.textContent = formatMessage(threshold_message, { discount });
            } else {
                const remaining = minItems - totalQuantity - theme.settings.printcount;
                // still below threshold
                // crossSellingCartCount.textContent = formatMessage(promo_message, { discount, remaining });
                 // start with schema message
                let msg = formatMessage(promo_message, { discount, remaining });

                // pluralize correctly
                if (remaining === 1) {
                msg = msg.replace("items", "item");
                }

                crossSellingCartCount.textContent = msg;
            }
        }else{
            crossSellingCartCount.innerText = `${totalQuantity} ${totalQuantity > 1 ? 'ITEMS' : 'ITEM'} ADDED TO CART`;
        }
        
       
    }

    function checkIfUserInteracts(){
        let actionDetected = false;

        const mouseOverHandler = (e) => {
            if (crossSellingContainer.contains(e.target)){
                actionDetected = true;
            }
        };
        const mouseDownHandler = (e) => {
            if (crossSellingContainer.contains(e.target)){
                actionDetected = true;
            }
        };
        const touchStartHandler = (e) => {
            if (crossSellingContainer.contains(e.target)){
                actionDetected = true;
            }
        };

        const slidersHandlar = (e) => {
            actionDetected = true;
        };

        document.addEventListener('mouseover', mouseOverHandler);
        document.addEventListener('mousedown', mouseDownHandler);
        document.addEventListener('touchstart', touchStartHandler);
        for (slider of crossSellingSliders){
            slider.addEventListener('touchstart', slidersHandlar);
        }

        timeoutId = setTimeout(() => {
            if (!actionDetected) {
                closeCrossSelling();
            }
            clearTimeout(timeoutId);
            document.removeEventListener('mouseover', mouseOverHandler);
            document.removeEventListener('mousedown', mouseDownHandler);
            document.removeEventListener('touchstart', touchStartHandler);
            for (slider of crossSellingSliders){
                slider.removeEventListener('touchstart', slidersHandlar);
            }
        }, 4000);
    }

    function singleVariantATC(variantID, trigger){
        trigger.classList.add('btn--loading');

        let formData = {
            'items': [{
            'id': variantID,
            'quantity': 1,
            'properties': {
                '_print_name': crossSellingCartCount.dataset.printtag
            }
            }]
        };
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            if (response.ok) {
                trigger.classList.remove('btn--loading');
                trigger.classList.add('btn--added');
                trigger.style.pointerEvents = 'none';
                setTimeout(() => {
                    trigger.classList.remove('btn--added');
                    trigger.style.pointerEvents = 'auto';
                    trigger.style.removeProperty('pointer-events');
                    trigger.style.removeProperty('display');
                }, 2000);
            } else {
                trigger.classList.remove('btn--loading');
                trigger.innerText = 'Sold out';
                if (trigger.classList.contains('dtc-cross-selling-item__button')){
                    setTimeout(() => {
                        trigger.innerText = 'QUICK ADD';
                    }, 2000);
                } else {
                    setTimeout(() => {
                        trigger.innerText =  'Build a Family Bundle';
                    }, 2000);
                }
                throw new Error('Variant out of stock');
            }
            return response.json();
        })
        .catch((error) => {
            trigger.classList.remove('btn--loading');
            throw error;
        });
    };
}

document.addEventListener('DOMContentLoaded', () => {
    renderCrossSelling();
});

document.addEventListener('swatch:updated', () => {
    renderCrossSelling();
});